import './About.css'
function About() {
  return (
    <section id="about" className="about">
      <h2>About Green Power Tech</h2>

      <p className="about-intro">
        Green Power Tech is a renewable energy solutions provider focused on
        delivering reliable, efficient, and sustainable power products. Our
        digital catalogue is designed to help dealers easily explore and share
        our offerings with customers.
      </p>

      <div className="about-cards">
        {/* Card 1 */}
        <div className="about-card">
          <h3>Who We Are</h3>
          <p>
            We specialize in solar energy products such as inverters, batteries,
            and panels. Our solutions are designed to support both residential
            and commercial energy needs with a strong focus on quality and
            performance.
          </p>
        </div>

        {/* Card 2 */}
        <div className="about-card">
          <h3>Our Mission</h3>
          <p>
            Our mission is to promote clean energy adoption by providing
            dependable products and clear product information that empowers
            dealers and customers to make informed decisions.
          </p>
        </div>

        {/* Card 3 */}
        <div className="about-card">
          <h3>Why This Catalogue</h3>
          <p>
            This digital catalogue replaces traditional printed brochures with
            a responsive, easy-to-use platform that works seamlessly across
            desktop and mobile devices.
          </p>
        </div>

        {/* Card 4 */}
        <div className="about-card">
          <h3>Company Details</h3>
          <p>
            <strong>Industry:</strong> Renewable Energy<br />
            <strong>Products:</strong> Solar Panels, Inverters, Batteries<br />
            <strong>Target Users:</strong> Dealers & Business Partners<br />
            <strong>Focus:</strong> Sustainability & Energy Efficiency
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
